export default __webpack_public_path__ + "static/media/demand.e8441aab.svg";